import { SnakeToCamel } from "~/types/utility.types";

// Recursively changes object properties from snake_case to camelCase
const snakeToCamel = <T extends object>(obj: T): SnakeToCamel<T> => {
  return Object.fromEntries(
    Object.entries(obj).map(([k, v]) => [
      k.replace(/^_/, "").replace(/_([a-z])/g, (_, c) => c.toUpperCase()),
      Array.isArray(v)
        ? v.map((item) =>
            typeof item === "object" && item !== null
              ? snakeToCamel(item)
              : item,
          )
        : v !== null && typeof v === "object"
          ? snakeToCamel(v)
          : v,
    ]),
  ) as SnakeToCamel<T>;
};

export { snakeToCamel };
